import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7536f8a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShopItem" }
const _hoisted_2 = { class: "ShopItem-img" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_4 = { class: "ShopItem-center" }
const _hoisted_5 = { class: "ShopItem-center-name" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { key: 0 }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import PopBtn from '@/components/common/PopBtn.vue'
import { calType } from '@/common/utils'
import ShopItemAction from '@/components/common/ShopItemAction.vue'
import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import LogoIcon from '@/components/common/LogoIcon.vue'
import BlackMask from '@/components/BlackGoods/BlackMask.vue'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // 前端展示场景 1-搜索列表;2-猜你喜欢;3-店铺商品列表;4-商品详情;5-收藏;6-已购买;7-足迹;8-担当推荐;9-系统推荐;10-找相似;11-关联商品;12-市场爆款
  showChannel: {
    type: Number,
    default: null
  }
},
  emits: ['unlike', 'cancelCollect'],
  setup(__props, { emit: emits }) {

const props = __props
const router = useRouter()
const routeLink = ref()




// 不喜欢操作回调
const unlike = (shopCode: string) => {
  emits('unlike', shopCode)
}

// 取消收藏操作回调
const cancelCollect = (shopCode: string) => {
  emits('cancelCollect', shopCode)
}

// 跳转至店铺列表
// const toShopList = (shopCode: string) => {
//   router.push(useRtfix('list', { query: { shopCode } }))
// }
const stopFn = (e: any) => {
  // 黑名单供应商禁止跳转
  if (props.item?.blackTag === 1) {
    ElMessage.warning(t('该供应商次品多，无法购买'))
    e.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(useRtfix)('list', { query: { shopCode: __props.item.shopCode } }),
    ref: (_value, _refs) => {
      _refs['routeLink'] = _value
      routeLink.value = _value
    },
    onClickCapture: stopFn
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PopBtn, { offset: "100%" }, {
          pop: _withCtx(() => [
            _createVNode(ShopItemAction, {
              item: __props.item,
              showChannel: __props.showChannel,
              onUnlike: unlike,
              onCancelCollect: cancelCollect
            }, null, 8, ["item", "showChannel"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                referrerPolicy: "no-referrer",
                class: "wrap",
                src: __props.item.shopMainImg,
                alt: __props.item.shopName,
                fit: "cover",
                lazy: ""
              }, {
                error: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["src", "alt"]),
              _createVNode(BlackMask, {
                type: "shop",
                item: __props.item
              }, null, 8, ["item"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LogoIcon, {
            class: "mr_5",
            type: _unref(calType)(__props.item),
            url: __props.item.productDetailUrl
          }, null, 8, ["type", "url"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.shopName), 1)
        ]),
        (__props.item.shopMajorCateName)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ShopItem-category",
              title: __props.item.shopMajorCateName.replace(/,/g, '、')
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.shopMajorCateName.split(','), (i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (i !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(i), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})